import React, { useState } from "react";

export default function ForSaleModal(props) {
  const itemprops = props.itemProps;
  const gallery =
    itemprops.itemGallery && itemprops.itemGallery.length
      ? itemprops.itemGallery
      : [itemprops.itemImage].filter(Boolean);

  const [mainImage, setMainImage] = useState(gallery[0]);

  return (
    <div className="sale-modal-container">
      <div className="heading-section sale-modal-heading">
        <div
          className="modal-title section-heading"
          dangerouslySetInnerHTML={{ __html: itemprops.itemTitle }}
        ></div>
        <div className="section-subheading sale-modal-price">
          {itemprops.itemPrice}
        </div>
      </div>
      <div className="sale-modal-body">
        {mainImage && (
          <div className="sale-modal-gallery">
            <img
              src={mainImage.sizes.large}
              alt=""
              className="sale-modal-main-image"
            />
            {gallery.length > 1 && (
              <div className="sale-modal-thumbnails">
                {gallery.map((image, index) => (
                  <img
                    src={image.sizes.medium}
                    alt=""
                    className={
                      "sale-modal-thumbnail" +
                      (image === mainImage ? " is-active" : "")
                    }
                    key={"galleryImage" + index}
                    onClick={() => setMainImage(image)}
                  />
                ))}
              </div>
            )}
          </div>
        )}
        <div
          className="sale-modal-text"
          dangerouslySetInnerHTML={{ __html: itemprops.itemText }}
        ></div>
        <div className="flex flex-right">
          <div className="contact-button">
            <a
              href={`mailto:info@corbyframing.ca?subject=${itemprops.itemTitle}`}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
